import { render, staticRenderFns } from "./MachDochEinfachPage.vue?vue&type=template&id=5fef9824&"
import script from "./MachDochEinfachPage.vue?vue&type=script&lang=js&"
export * from "./MachDochEinfachPage.vue?vue&type=script&lang=js&"
import style0 from "./MachDochEinfachPage.vue?vue&type=style&index=0&id=5fef9824&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports